import { State } from '@/helpers/entities/enums/v2/State';
import { EcommerceProductOptionModel } from '@/helpers/entities/models/EcommerceProductOptionModel';
export class EcommerceProductOptionInputModel {
    constructor(payload = null) {
        if (payload) {
            if (payload instanceof EcommerceProductOptionModel) {
                Object.assign(this, {
                    ...payload,
                    price: Number(payload.price),
                    compareAtPrice: Number(payload.compareAtPrice),
                });
            }
            else {
                const { uuid, name, price, compareAtPrice, limited, stockQuantity, boughtAndReservedCount, } = payload;
                Object.assign(this, {
                    uuid,
                    name,
                    price: Number(price),
                    compareAtPrice: Number(compareAtPrice),
                    limited,
                    stockQuantity,
                    boughtAndReservedCount,
                    published: true,
                    digitalProduct: false,
                });
            }
            if (payload.hidden) {
                this.markAsHidden();
            }
            else if (payload.published) {
                this.markAsIdle();
            }
        }
        else {
            this.init();
        }
    }
    setName(name) {
        this.name = name;
    }
    markAsDeleted() {
        this.hidden = false;
        this.state = State.deleted;
    }
    markAsHidden() {
        this.hidden = true;
        this.state = State.hidden;
    }
    markAsIdle() {
        this.hidden = false;
        this.state = State.idle;
    }
    markAsNew() {
        this.hidden = false;
        this.state = State.new;
    }
    get fresh() {
        return this.state === State.new;
    }
    get deleted() {
        return this.state === State.deleted;
    }
    get isPublished() {
        return this.published;
    }
    setSectionName(sectionName) {
        this.sectionName = sectionName;
    }
    setPrice(price = 0) {
        this.price = price;
    }
    init() {
        this.uuid = null;
        this.name = null;
        this.price = 0;
        this.compareAtPrice = null;
        this.stockQuantity = null;
        this.limited = false;
        this.published = true;
        this.boughtAndReservedCount = null;
        this.digitalProduct = false;
        this.markAsNew();
        this.setPrice();
    }
}
